module.exports = __webpack_public_path__ + "023dfe78db0cf2427b29730d86da5a31.png";